import type { Child, Family, Friend, Message, User } from '@/types/domain';

const createdAt = '2026-06-08T10:00:00.000Z';

export const family: Family = {
  id: 'fam-mueller',
  name: 'Familie Mueller',
  screenTimeMinutes: 25,
  createdAt
};

export const parents: User[] = [
  {
    id: 'usr-max',
    familyId: family.id,
    role: 'parent',
    firstName: 'Max',
    lastName: 'Mueller',
    email: 'max@example.test',
    isBlocked: false,
    createdAt
  }
];

export const children: Child[] = [
  {
    id: 'child-emma',
    familyId: family.id,
    firstName: 'Emma',
    birthDate: '2021-03-12',
    avatar: 'sun',
    favoriteColor: '#fb7185',
    profileImageUrl: null,
    pinEnabled: false,
    isActive: true
  },
  {
    id: 'child-leon',
    familyId: family.id,
    firstName: 'Leon',
    birthDate: '2020-09-04',
    avatar: 'rocket',
    favoriteColor: '#0ea5e9',
    profileImageUrl: null,
    pinEnabled: true,
    isActive: true
  }
];

export const friends: Friend[] = [
  {
    id: 'friend-mia',
    childId: 'child-emma',
    friendChildId: 'child-mia',
    displayName: 'Mia',
    avatar: 'house-pink',
    houseColor: '#fb7185',
    birthDate: '2020-06-08',
    source: 'manual',
    status: 'active'
  },
  {
    id: 'friend-noah',
    childId: 'child-emma',
    friendChildId: 'child-noah',
    displayName: 'Noah',
    avatar: 'house-blue',
    houseColor: '#38bdf8',
    birthDate: null,
    source: 'manual',
    status: 'active'
  },
  {
    id: 'friend-leon-mia',
    childId: 'child-leon',
    friendChildId: 'child-mia',
    displayName: 'Mia',
    avatar: 'house-green',
    houseColor: '#22c55e',
    birthDate: '2020-06-08',
    source: 'manual',
    status: 'active'
  }
];

export const messages: Message[] = [
  {
    id: 'msg-received-1',
    senderChildId: 'child-mia',
    receiverChildId: 'child-emma',
    familyId: family.id,
    type: 'play_request',
    content: 'Mia fragt: Willst du heute im Garten spielen?',
    mediaUrl: null,
    status: 'received',
    createdAt,
    approvedBy: null,
    approvedAt: null,
    metadata: { place: 'Garten', time: 'Heute Nachmittag', isNew: true }
  },
  {
    id: 'msg-drawing-1',
    senderChildId: 'child-emma',
    receiverChildId: 'child-mia',
    familyId: family.id,
    type: 'drawing',
    content: 'Eine Zeichnung ist bereit zur Elternfreigabe.',
    mediaUrl: null,
    status: 'pending',
    createdAt,
    approvedBy: null,
    approvedAt: null,
    metadata: { colors: ['rose', 'sky'] }
  },
  {
    id: 'msg-play-1',
    senderChildId: 'child-leon',
    receiverChildId: 'child-mia',
    familyId: family.id,
    type: 'play_request',
    content: 'Willst du spielen? Spielplatz, heute Nachmittag.',
    mediaUrl: null,
    status: 'approved',
    createdAt,
    approvedBy: 'usr-max',
    approvedAt: createdAt,
    metadata: { place: 'Spielplatz', time: 'Heute Nachmittag' }
  }
];
